(function () {
  "use strict";

  var cfg = window.CEC_CONFIG || {};
  var ENDPOINT = cfg.endpoint;
  if (!ENDPOINT) {
    console.warn("[callec-chatbot] endpoint not configured");
    return;
  }
  var HANDOFF_ENDPOINT = ENDPOINT.replace(/\/chat\/?$/, "/handoff");
  var SEARCH_ENDPOINT = ENDPOINT.replace(/\/chat\/?$/, "/search");
  var FEEDBACK_ENDPOINT = ENDPOINT.replace(/\/chat\/?$/, "/feedback");
  var EVENT_ENDPOINT = ENDPOINT.replace(/\/chat\/?$/, "/event");
  var SIZECHART_ENDPOINT = ENDPOINT.replace(/\/chat\/?$/, "/sizechart");
  var VARIANTS_ENDPOINT = ENDPOINT.replace(/\/chat\/?$/, "/variants");
  var TRANSCRIPT_ENDPOINT = ENDPOINT.replace(/\/chat\/?$/, "/transcript");

  // =====================================================================
  // 文言辞書（ここだけ直せば表示テキストを変更できます）
  //  - {xxx} は差し込み（受付番号・商品名など）。記号は消さないでください。
  //  - Shopify管理画面のテーマ設定でも主要文言は上書きできます（設定 > テーマ > カスタマイズ）。
  //    設定した項目は下記デフォルトより優先されます。
  // =====================================================================
  var DEFAULT_TEXT = {
    // --- 基本UI ---
    greeting: "こんにちは！CALLサポートです。送料・サイズ・在庫・おすすめなど、お気軽にどうぞ🙂",
    headerTitle: "CALL サポート",
    headerSub: "AIが情報でお答えします",
    launcherAria: "チャットで質問する",
    closeAria: "閉じる",
    inputPlaceholder: "メッセージを入力...",
    inputAria: "メッセージ",
    inputLocked: "お手続き中です。ボタンでお進みください",
    sendBtn: "送信",
    blank: "（未入力）",
    soldout: "在庫切れ",
    cardSize: "サイズ相談",

    // --- 常設チップ（入力欄の上のショートカット） ---
    chipMenu: "メニュー",
    chipShipping: "送料は？",
    chipSize: "サイズ選び",
    chipReturn: "返品・交換",

    // --- トップメニュー ---
    topMenuPrompt: "ご用件をお選びください。メッセージ入力でもお答えします。",
    menuReturn: "返品・交換したい",
    menuSize: "サイズを知りたい",
    menuFaq: "よくある質問",
    menuOther: "その他",
    backToMenu: "← メニューに戻る",

    // --- よくある質問メニュー ---
    faqPrompt: "知りたいことをお選びください。",
    faqHeadDelivery: "配送・お届け",
    faqHeadOther: "お支払い・その他",
    faqShippingFee: "送料はいくら？",
    faqDeliveryDays: "お届けまでの日数",
    faqFreeShip: "送料無料の条件",
    faqOrderStatus: "注文状況・追跡を確認",
    faqPayment: "支払い方法",
    faqGift: "ギフトラッピング",
    faqReceipt: "領収書の発行",
    faqHours: "営業時間・問い合わせ先",

    // --- 配送メニュー（未使用時の予備） ---
    deliveryPrompt: "配送についてのご質問をお選びください。",

    // --- 注文状況 ---
    orderStatusLink: "配送状況・追跡を見る",
    orderStatusShow: "ご注文状況はこちらです。配送・追跡の詳細は各注文のリンクからご確認ください。",
    orderNoneLoggedIn: "お客様のアカウントに、表示できるご注文が見つかりませんでした。担当者が確認しますので、スタッフ相談へお進みください。",
    orderStaffBtn: "スタッフに相談する",
    orderLoginPrompt: "ログインいただくと、注文状況・追跡をその場で確認できます。ご注文番号でのお問い合わせも可能です。",
    orderLoginBtn: "ログインして確認する",
    orderByNumberBtn: "注文番号で問い合わせる",
    orderStatusShown: "[注文状況を表示しました]",
    otherCount: "他{n}点",

    // --- 返品・交換フロー ---
    flowLaunch: "返品・交換のお手続き",
    flowLaunchBtn: "返品・交換のお手続きを始める",
    flowNavBack: "↩ 戻る",
    flowNavRestart: "最初から",
    menuPrompt: "ご用件をお選びください。",
    kindDefectInuse: "商品の不良",
    kindExchange: "交換",
    kindReturn: "返品",
    returnCondition: "返品は【商品到着後30日以内・未使用・未洗濯・弊社タグ付きの商品・送料はお客様負担】が条件です(期限を過ぎてもご相談ください)。条件を満たしますか？",
    returnCondMeet: "満たす",
    returnCondUnknown: "わからない",
    returnCondUnknownNote: "返品可否の確認希望",
    placePrompt: "ご購入場所をお選びください。",
    placeStore: "実店舗",
    placeEc: "オンライン(EC)",
    storeNamePrompt: "ご購入店舗名を入力してください。",
    storeOptionalPrompt: "レシート番号・ご購入日があればご入力ください（任意・空欄でも進めます）。",
    ecRecentPrompt: "最近のご注文はこちらです。該当のご注文をタップしてください。",
    purchaseOn: "{date}ご購入分",
    latestTag: "（最新）",
    ecOrderOther: "別の注文／手入力",
    ecNoOrderFound: "最近のご注文が見つかりませんでした。ご注文番号を手入力で進めます。",
    ecLoginHint: "ログインすると、ご注文を選ぶだけで入力できます。",
    ecLoginBtn: "ログインして選ぶ",
    ecManualBtn: "このまま手入力で進める",
    ecManualPrompt: "ご注文番号をご入力ください（発送完了メールに記載の #で始まる番号）。",
    itemPickPrompt: "どの商品についてですか？対象をお選びください。",
    itemPickAll: "すべて（全{n}点）",
    productInfoPrompt: "対象商品の情報をご入力ください。",
    fieldItem: "品番 または 商品名",
    fieldColor: "カラー",
    fieldSize: "サイズ",
    reasonPrompt: "交換の理由をお選びください。",
    reasonInitialDefect: "初期不良",
    reasonColor: "カラー変更",
    reasonSize: "サイズ変更",
    exPickItem: "交換する商品をお選びください。",
    exDefectPick: "不良のある商品をお選びください。",
    exAll: "すべて",
    exLoading: "在庫を確認しています…",
    exChooseSize: "「{item}」の交換後のサイズをお選びください（現在 {cur}）。",
    exChooseColor: "「{item}」の交換後のカラーをお選びください（現在 {cur}）。",
    exNoStock: "申し訳ございません、「{item}」で交換できる在庫が見つかりませんでした。スタッフがご案内します。",
    exContinue: "続けて交換しますか？",
    exMore: "他の商品も交換する（残り{n}点）",
    exDone: "これで確定",
    changeColorPrompt: "ご希望のカラーをご入力ください。",
    changeSizePrompt: "ご希望のサイズをご入力ください。",
    receivePrompt: "交換品の受取方法をお選びください。",
    receiveShip: "配送希望",
    receiveStore: "店舗で受取",
    receiveStorePrompt: "受取をご希望の最寄り店舗名をご入力ください。",
    returnReasonPrompt: "差し支えなければ返品理由をお選びください（任意）。",
    returnReasonSizeNg: "サイズが合わない",
    returnReasonImageNg: "イメージ違い",
    returnReasonOther: "その他",
    returnReasonSkip: "スキップ",
    confirmPrompt: "以下の内容で受付します。よろしければ「確定」を押してください。",
    confirmBtn: "確定",
    confirmEdit: "修正する",

    // --- 受付サマリのラベル ---
    sumYougen: "ご用件",
    sumPlace: "購入場所",
    sumOrder: "ご注文番号",
    sumReceipt: "レシート/購入日",
    sumProduct: "商品",
    sumChange: "ご希望",
    sumReceive: "受取方法",
    sumReturnReason: "返品理由",
    sumStore: "実店舗（{name}）",
    sumRecvStore: "店舗（{name}）",
    recvShipLabel: "配送希望",
    recvStoreLabel: "店舗希望",

    // --- 受付完了・ハンドオフ ---
    handoffSuccess: "ありがとうございます。受付番号は {ticket} です。下記をコピーして公式LINEにお送りください。",
    handoffLogHeader: "【受付内容（コピーしてLINEへ送信してください）】",
    handoffCopyOnly: "コピーのみ",
    handoffCopied: "コピーしました",
    handoffLineBtn: "コピーしてLINEへ",
    handoffNote: "受付番号: {ticket}／上の内容をコピーして公式LINEにお送りください。",

    // --- スタッフ相談・注文照会 ---
    staffPrompt: "ご相談内容を一言でお書きください。担当者がお調べして折り返します。",
    orderNumberPrompt: "ご注文番号（確認メールに記載の #数字）をご入力ください。わからない場合は空欄のまま送信いただけます。",
    orderNumberNote: "注文状況・配送状況の確認希望",

    // --- 商品検索 ---
    searchPrompt: "お探しの商品を入力いただくか、カテゴリをお選びください。",
    searchTops: "トップス",
    searchBottoms: "ボトムス",
    searchOuter: "アウター",
    searchKeyword: "キーワードで探す",
    searchResultLead: "こちらはいかがでしょうか。",
    searchNoResult: "該当する商品が見つかりませんでした。別のキーワードでお試しいただくか、スタッフにご相談ください。",

    // --- サイズ診断 ---
    sizeAskProduct: "サイズをお調べする商品を教えてください。",
    sizeNotFound: "その商品が見つかりませんでした。商品名を変えるか、メニューからお探しください。",
    sizeNoChart: "申し訳ございません、この商品はサイズの提案ができません。寸法などの詳細は商品ページの『サイズ詳細』をご確認ください。",
    sizeViewProduct: "商品ページを見る",
    buildSlim: "細身",
    buildStd: "標準",
    buildSolid: "筋肉質",
    buildPlump: "大きめ",
    diagStart: "「{title}」のサイズを、実寸に照らして診断します。",
    askHeight: "まず身長を教えてください（cm）。",
    heightInvalid: "身長をcmの数字でご入力ください（例：170）。",
    askBuild: "体型のイメージに近いものは？",
    askWeight: "体重がわかると精度が上がります（任意）。空欄のまま送信でスキップできます。",
    diagNoChart: "この商品は実寸データから自動判定できませんでした。担当AIが確認します。",
    recoLead: "身長{h}cm・{build}{weight}の方への、この商品のおすすめです。",
    pastFitAsk: "前回の「{title}」（{size}）の着心地はいかがでしたか？",
    pastFitFromNote: "マイクローゼットに残っている「{fit}」というサイズ感メモを反映しています。",
    profileSave: "この体型を登録する",
    profileSaved: "登録しました。次回から入力なしでご案内します。",
    profileSaveFail: "登録できませんでした。時間をおいてお試しください。",
    profileInvite: "この体型を登録しておくと、次回から入力なしでご案内できます。",
    pastFitJust: "ちょうど良かった",
    pastFitLarge: "少し大きかった",
    pastFitSmall: "少し小さかった",
    pastCardLead: "前回の「{title}」{size}を基準にした、この商品のおすすめです。",
    pastNoChart: "前回商品の実寸が取得できませんでした。体型で診断します。",
    sizeCardLabel: "おすすめサイズ",
    sizeCardDash: "—",
    wearSegLabel: "着方で微調整",
    wearSnug: "すっきり",
    wearJust: "ジャスト",
    wearLoose: "ゆったり",
    sizeMore: "もっと詳しく相談する",
    sizeMorePh: "例：肩幅が気になる／手持ちのMがちょうど良い",
    sizeCardBack: "メニューに戻る",
    sizeRedo: "身長・体型を入力し直す",

    // --- フィードバック（👍👎） ---
    feedbackQ: "この回答は役に立ちましたか？",
    feedbackYes: "はい",
    feedbackNo: "いいえ",
    feedbackThanks: "ありがとうございます！",
    feedbackNoThanks: "ご意見ありがとうございます。お困りの場合はスタッフにご相談ください。",

    // --- 汎用返信・エラー ---
    aiFallback: "すみません、もう一度お試しください。",
    errComm: "通信エラーが発生しました。少し後にもう一度お試しください。",
    errCommShort: "通信エラーが発生しました。少し後にお試しください。",
    errCommLine: "通信エラーが発生しました。お手数ですが公式LINEより直接ご連絡ください。",

    // --- 入力プレースホルダ（例文） ---
    phStoreName: "例：イオンモール福岡店",
    phReceipt: "例：レシート No.1234 / 6月20日 (任意)",
    phOrderNumber: "例：#1001",
    phItem: "例：251-1321-09 または ワイドパンツ",
    phColor: "例：ブラック",
    phSize: "例：M",
    phChangeColor: "例：ネイビー",
    phChangeSize: "例：L",
    phHeight: "例：170",
    phWeight: "例：62（空欄で送信＝スキップ）",
    phSizeProduct: "例：モックネック / ワイドパンツ",
    phSearchKeyword: "例：黒 ワイドパンツ",
    phStaff: "例：商品Aの再入荷予定を知りたい",
    phOrderNumberOpt: "例：#12345（空欄可）",

    // --- 注文ステータス表示語（Shopifyの状態→日本語） ---
    financial: { paid: "支払い済み", pending: "支払い待ち", refunded: "返金済み", partially_refunded: "一部返金", voided: "無効", authorized: "与信済み" },
    fulfillment: { fulfilled: "発送済み", partial: "一部発送", restocked: "返品処理済み", unfulfilled: "未発送", _default: "未発送" }
  };

  // テーマ設定(cfg.text)でデフォルトを上書き（空文字/未設定は無視）。1階層のネストにも対応。
  function mergeText(base, ov) {
    var o = JSON.parse(JSON.stringify(base));
    if (!ov) return o;
    for (var k in ov) {
      if (!ov.hasOwnProperty(k)) continue;
      var v = ov[k];
      if (v == null || v === "") continue;
      if (typeof v === "object" && !Array.isArray(v) && typeof o[k] === "object") {
        for (var j in v) { if (v.hasOwnProperty(j) && v[j] != null && v[j] !== "") o[k][j] = v[j]; }
      } else {
        o[k] = v;
      }
    }
    return o;
  }
  var T = mergeText(DEFAULT_TEXT, cfg.text);
  // {placeholder} を差し込んで返す。
  function t(str, vars) {
    if (!vars) return str;
    return String(str).replace(/\{(\w+)\}/g, function (_, k) { return vars[k] != null ? vars[k] : ""; });
  }

  // 軽量UIイベント送信(開封/自己解決)。応答は不要。
  function sendEvent(kind) {
    try {
      var payload = JSON.stringify({ session_id: sessionId, kind: kind });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(EVENT_ENDPOINT, payload);
      } else {
        fetch(EVENT_ENDPOINT, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true }).catch(function () {});
      }
    } catch (e) {}
  }

  // チャット関与を注文に紐付け(cart属性 cec_session_id)。CV計測用。1タブ1回。
  var CART_TAG_KEY = "cec_cart_tagged";
  function tagCart() {
    try {
      if (sessionStorage.getItem(CART_TAG_KEY)) return;
      sessionStorage.setItem(CART_TAG_KEY, "1");
    } catch (e) {}
    try {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { cec_session_id: sessionId } }),
      }).catch(function () {});
    } catch (e) {}
  }
  var GREETING = cfg.greeting || T.greeting;
  var FLOW_LAUNCH = T.flowLaunch;
  var CUSTOMER = cfg.customer || { loggedIn: false, orders: [], loginUrl: "/account/login" };
  // 注文状況・追跡の意図(ログイン中はAI/サーバを使わず注入済みデータで即表示)。
  var ORDER_INTENT = /(注文状況|注文の状況|配送状況|発送状況|発送された|追跡|今どこ|届かない|届いてない|まだ届|注文番号)/;

  var history = []; // [{role, content(text)}] sent to the worker
  var sending = false;

  // セッションID(localStorageで保持)。D1ログの紐付けに使う。
  var sessionId;
  try {
    sessionId = localStorage.getItem("cec_session");
    if (!sessionId) {
      sessionId = "s_" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      localStorage.setItem("cec_session", sessionId);
    }
  } catch (e) {
    sessionId = "s_" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

  // 会話の永続化(同一タブ内)。ページ遷移してもチャットが消えないようにする。
  // ボタン群やカードは復元せずテキストのみ(復元後はチップから再操作できる)。
  var LOG_KEY = "cec_log_v1";
  var msgLog = [];
  var savedState = null;
  try {
    savedState = JSON.parse(sessionStorage.getItem(LOG_KEY) || "null");
  } catch (e) { savedState = null; }
  function persistLog() {
    try {
      sessionStorage.setItem(LOG_KEY, JSON.stringify({ m: msgLog.slice(-40), h: history.slice(-12) }));
    } catch (e) {}
  }
  function recordLog(role, text) {
    msgLog.push({ role: role, text: String(text) });
    persistLog();
    scheduleTranscript();
  }

  // 全会話ログ: セッションの全やりとりをサーバへ保存(sendBeacon・best-effort)。
  // ボタン操作・サイズ診断も含めた全履歴を管理画面で見られるようにする。
  var _tsTimer = null, _tsLast = 0;
  function sendTranscript() {
    _tsLast = Date.now();
    // ユーザーが1回でも操作(ボタン選択/入力)したセッションのみ保存(開いただけはui_eventsのopenで把握)。
    if (!msgLog.some(function (m) { return m.role === "user"; })) return;
    try {
      var payload = JSON.stringify({
        session_id: sessionId,
        product_handle: (cfg.product && cfg.product.handle) || null,
        messages: msgLog.slice(-200),
      });
      if (navigator.sendBeacon) navigator.sendBeacon(TRANSCRIPT_ENDPOINT, payload);
      else fetch(TRANSCRIPT_ENDPOINT, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true }).catch(function () {});
    } catch (e) {}
  }
  // 連続追記を間引いて送る(1.5秒デバウンス)。離脱時は即時 flush。
  function scheduleTranscript() {
    if (_tsTimer) clearTimeout(_tsTimer);
    _tsTimer = setTimeout(function () { _tsTimer = null; sendTranscript(); }, 1500);
  }
  function flushTranscript() { if (_tsTimer) { clearTimeout(_tsTimer); _tsTimer = null; } sendTranscript(); }
  document.addEventListener("visibilitychange", function () { if (document.visibilityState === "hidden") flushTranscript(); });
  window.addEventListener("pagehide", flushTranscript);

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  // ---- build DOM ----
  var root = el("div", "cec-bot");

  var launcher = el(
    "button",
    "cec-launcher",
    '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>'
  );
  launcher.setAttribute("aria-label", T.launcherAria);

  var panel = el("div", "cec-panel");
  panel.innerHTML =
    '<div class="cec-header"><div>' + escapeHtml(T.headerTitle) + '<small>' + escapeHtml(T.headerSub) + '</small></div><button class="cec-close" aria-label="' + escapeHtml(T.closeAria) + '">×</button></div>' +
    '<div class="cec-log" role="log" aria-live="polite"></div>' +
    '<div class="cec-suggest"></div>' +
    '<div class="cec-input"><textarea rows="1" placeholder="' + escapeHtml(T.inputPlaceholder) + '" aria-label="' + escapeHtml(T.inputAria) + '"></textarea><button class="cec-send">' + escapeHtml(T.sendBtn) + '</button></div>';

  root.appendChild(panel);
  root.appendChild(launcher);
  document.body.appendChild(root);

  var log = panel.querySelector(".cec-log");
  var suggestWrap = panel.querySelector(".cec-suggest");
  var textarea = panel.querySelector("textarea");
  var sendBtn = panel.querySelector(".cec-send");

  // ---- rendering ----
  function scrollDown() {
    log.scrollTop = log.scrollHeight;
  }

  // AI応答に混ざるMarkdown記号を除去(ウィジェットは素のテキスト表示のため)。
  function stripMd(s) {
    if (s == null) return "";
    return String(s)
      .replace(/\*\*([^*]+)\*\*/g, "$1")
      .replace(/__([^_]+)__/g, "$1")
      .replace(/(^|[^*])\*([^*\n]+)\*/g, "$1$2")
      .replace(/`([^`]*)`/g, "$1")
      .replace(/\[([^\]]+)\]\(([^)]+)\)/g, "$1 $2")
      .replace(/^\s{0,3}#{1,6}\s*/gm, "")
      .replace(/^\s{0,3}[-*]\s+/gm, "・");
  }

  // DOM描画のみ(復元リプレイ用)。
  function renderMsgDom(role, text) {
    var m = el("div", "cec-msg " + (role === "user" ? "cec-user" : "cec-bot"));
    m.textContent = role === "user" ? text : stripMd(text);
    log.appendChild(m);
    scrollDown();
    return m;
  }

  function addMsg(role, text) {
    // 最初のユーザー操作でチャット関与を注文に紐付け(CV計測)。
    if (role === "user") tagCart();
    recordLog(role, text);
    return renderMsgDom(role, text);
  }

  function addProducts(products) {
    if (!products || !products.length) return;
    var wrap = el("div", "cec-products");
    products.slice(0, 4).forEach(function (p) {
      var a = el("a", "cec-card");
      a.href = p.url;
      a.target = "_blank";
      a.rel = "noopener";
      var img = p.image
        ? '<img src="' + p.image + '" alt="" loading="lazy">'
        : "";
      var price = p.available
        ? '<div class="cec-card-p">' + (p.price || "") + "</div>"
        : '<div class="cec-card-p cec-soldout">' + escapeHtml(T.soldout) + "</div>";
      a.innerHTML =
        img +
        '<div><div class="cec-card-t">' + escapeHtml(p.title) + "</div>" + price + "</div>";
      // カードから直接サイズ相談へ(リンク遷移は抑止)。
      var sb = el("button", "cec-card-size", T.cardSize);
      (function (title, handle) {
        sb.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          startSizeIntakeFor(title, handle);
        });
      })(p.title, p.handle);
      a.appendChild(sb);
      wrap.appendChild(a);
    });
    log.appendChild(wrap);
    scrollDown();
  }

  // ログイン顧客の注文状況をクライアント側で描画(AI/サーバ不要)。
  function financialJa(s) { return T.financial[s] || ""; }
  function fulfillmentJa(s) { return T.fulfillment[s] || T.fulfillment._default; }
  function renderOrders() {
    var orders = CUSTOMER.orders || [];
    var wrap = el("div", "cec-orders");
    orders.forEach(function (o) {
      var st = [fulfillmentJa(o.fulfillment)];
      var fin = financialJa(o.financial);
      if (fin) st.push(fin);
      var card = el("div", "cec-order");
      card.innerHTML =
        '<div class="cec-order-h"><b>' + escapeHtml(o.name || "") + "</b>" +
        (o.created ? '<span class="cec-order-d">' + escapeHtml(o.created) + "</span>" : "") + "</div>" +
        '<div class="cec-order-s">' + escapeHtml(st.join("・")) + "</div>" +
        (o.summary ? '<div class="cec-order-i">' + escapeHtml(o.summary) + (o.items && o.items.length > 1 ? " " + t(T.otherCount, { n: o.items.length - 1 }) : "") + "</div>" : "");
      if (o.statusUrl) {
        var a = el("a", "cec-order-link", T.orderStatusLink);
        a.href = o.statusUrl;
        a.target = "_blank";
        a.rel = "noopener";
        card.appendChild(a);
      }
      wrap.appendChild(card);
    });
    log.appendChild(wrap);
    scrollDown();
  }

  function addHandoff(h) {
    if (!h || !h.copyText) return;
    // ページ遷移後も受付番号・本文を参照できるようテキストとして永続化。
    recordLog("bot", T.handoffLogHeader + "\n" + h.copyText);
    var wrap = el("div", "cec-handoff");
    var pre = el("pre", "cec-copybox");
    pre.textContent = h.copyText;
    wrap.appendChild(pre);

    var actions = el("div", "cec-handoff-actions");
    var copyBtn = el("button", "cec-btn cec-btn-copy", T.handoffCopyOnly);
    copyBtn.addEventListener("click", function () {
      var done = function () {
        copyBtn.textContent = T.handoffCopied;
        setTimeout(function () { copyBtn.textContent = T.handoffCopyOnly; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(h.copyText).then(done, function () { selectText(pre); });
      } else {
        selectText(pre);
      }
    });
    actions.appendChild(copyBtn);

    if (h.lineUrl) {
      // 押下時にクリップボードへコピーしてからLINEを開く(プリフィル可否に関わらず貼り付けるだけに)。
      var lineBtn = el("a", "cec-btn cec-btn-line", T.handoffLineBtn);
      lineBtn.href = h.lineUrl;
      lineBtn.target = "_blank";
      lineBtn.rel = "noopener";
      lineBtn.addEventListener("click", function () {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(h.copyText).catch(function () {});
        }
      });
      actions.appendChild(lineBtn);
    }
    wrap.appendChild(actions);

    var note = el("div", "cec-handoff-note");
    note.textContent = t(T.handoffNote, { ticket: h.ticket || "" });
    wrap.appendChild(note);

    log.appendChild(wrap);
    scrollDown();
  }

  function selectText(node) {
    var range = document.createRange();
    range.selectNodeContents(node);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function showTyping() {
    var t = el("div", "cec-msg cec-bot");
    t.innerHTML = '<span class="cec-typing"><span></span><span></span><span></span></span>';
    log.appendChild(t);
    scrollDown();
    return t;
  }

  // 常設チップ(よく使う入口へのショートカット)。タップ後は各定型フローへ。
  // 下部の常設ボタンは「メニュー」1つ(横全幅)。押すとトップメニューへ戻る。
  var CHIPS = [
    { label: T.chipMenu, on: function () { showTopMenu(); } },
  ];
  function renderSuggestions() {
    suggestWrap.innerHTML = "";
    CHIPS.forEach(function (c) {
      var chip = el("button", "cec-chip", escapeHtml(c.label));
      chip.addEventListener("click", c.on);
      suggestWrap.appendChild(chip);
    });
  }

  // ---- 交換・返品ガイドフロー(ボタン式・決定的) ----
  var flow = null; // { data:{}, stack:[{id,data}] }

  function botSay(text) { addMsg("bot", text); recordTurn("assistant", text); }

  // 手続きのやりとりを受付単位で保存するため、bot質問と客の選択/入力を記録。
  function recordTurn(role, text) {
    if (flow && flow.transcript) flow.transcript.push({ role: role, text: String(text) });
  }

  function clone(o) { return JSON.parse(JSON.stringify(o)); }

  // フロー中はフリー入力を無効化(二重化防止)。
  function setInputEnabled(on) {
    textarea.disabled = !on;
    sendBtn.disabled = !on;
    textarea.placeholder = on ? T.inputPlaceholder : T.inputLocked;
  }

  // 離脱分析: 到達ステップをbest-effortで送信。
  function flowBeacon(stepId, completed) {
    try {
      var payload = JSON.stringify({
        session_id: sessionId,
        kind: (flow && flow.data && flow.data.kind) || "",
        step: stepId,
        completed: !!completed,
      });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(HANDOFF_ENDPOINT.replace(/\/handoff$/, "/flow-event"), payload);
      }
    } catch (e) {}
  }

  // ステップ遷移(履歴push + 離脱記録 + 描画)。
  function step(id) {
    flow.stack.push({ id: id, data: clone(flow.data) });
    flowBeacon(id, id === "confirm");
    render(id);
  }

  // 1つ前のステップへ戻る(データも巻き戻す)。
  function goBack() {
    if (!flow || flow.stack.length < 2) return;
    flow.stack.pop();
    var prev = flow.stack[flow.stack.length - 1];
    flow.data = clone(prev.data);
    render(prev.id);
  }

  function restartFlow() {
    var data = {};
    flow = { data: data, stack: [], transcript: [] };
    step("menu");
  }

  // 各ステップ下部の操作(戻る/最初から)。
  function appendFlowNav() {
    if (!flow) return;
    var nav = el("div", "cec-flownav");
    if (flow.stack.length > 1) {
      var back = el("button", "cec-flownav-btn", T.flowNavBack);
      back.addEventListener("click", goBack);
      nav.appendChild(back);
    }
    var restart = el("button", "cec-flownav-btn", T.flowNavRestart);
    restart.addEventListener("click", restartFlow);
    nav.appendChild(restart);
    log.appendChild(nav);
    scrollDown();
  }

  // 選択ボタン群を描画。options: [{label, on}]
  // options: [{label, on, icon?, variant?} | {header}]  header=区切り見出し, variant:'primary' で強調, ラベル先頭「←」で戻るリンク。
  function renderChoices(options) {
    var wrap = el("div", "cec-choices");
    options.forEach(function (o) {
      if (o.header) { wrap.appendChild(el("div", "cec-choice-head", escapeHtml(o.header))); return; }
      var isBack = /^←/.test(o.label);
      var cls = "cec-choice" + (isBack ? " cec-choice-back" : (o.variant === "primary" ? " cec-choice-accent" : ""));
      var b = el("button", cls);
      if (isBack || o.variant === "primary") {
        b.textContent = o.label;
      } else {
        b.innerHTML =
          (o.icon ? '<span class="cec-choice-ic">' + o.icon + "</span>" : "") +
          '<span class="cec-choice-tx">' + escapeHtml(o.label) + '</span><span class="cec-choice-ch">›</span>';
      }
      b.addEventListener("click", function () {
        if (wrap.dataset.done) return;
        wrap.dataset.done = "1";
        wrap.querySelectorAll("button").forEach(function (x) { x.disabled = true; });
        addMsg("user", o.label);
        recordTurn("user", o.label);
        o.on();
      });
      wrap.appendChild(b);
    });
    log.appendChild(wrap);
    appendFlowNav();
    scrollDown();
  }

  // 自由入力1項目。required=trueなら空不可。
  function renderInput(placeholder, required, onValue) {
    var wrap = el("div", "cec-inline");
    var inp = el("input", "cec-inline-input");
    inp.type = "text";
    inp.placeholder = placeholder || "";
    var btn = el("button", "cec-inline-btn", T.sendBtn);
    function submit() {
      var v = inp.value.trim();
      if (required && !v) { inp.focus(); return; }
      if (wrap.dataset.done) return;
      wrap.dataset.done = "1";
      inp.disabled = true; btn.disabled = true;
      addMsg("user", v || T.blank);
      recordTurn("user", v || T.blank);
      onValue(v);
    }
    btn.addEventListener("click", submit);
    inp.addEventListener("keydown", function (e) {
      // IME変換確定のEnterで誤送信しないよう、変換中は無視。
      if (e.key === "Enter" && !e.isComposing && e.keyCode !== 229) { e.preventDefault(); submit(); }
    });
    wrap.appendChild(inp); wrap.appendChild(btn);
    log.appendChild(wrap); appendFlowNav(); scrollDown(); inp.focus();
  }

  // 複数項目を別々の欄で入力させるフォーム。fields=[{key,label,placeholder,required}]
  function renderInputs(fields, onValues) {
    var wrap = el("div", "cec-form");
    var inputs = [];
    fields.forEach(function (f) {
      var row = el("div", "cec-form-row");
      var lab = el("label", "cec-form-label", escapeHtml(f.label));
      var inp = el("input", "cec-inline-input");
      inp.type = "text";
      inp.placeholder = f.placeholder || "";
      row.appendChild(lab); row.appendChild(inp);
      wrap.appendChild(row);
      inputs.push({ f: f, inp: inp });
    });
    var btn = el("button", "cec-inline-btn cec-form-btn", T.sendBtn);
    function submit() {
      if (wrap.dataset.done) return;
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].f.required && !inputs[i].inp.value.trim()) { inputs[i].inp.focus(); return; }
      }
      wrap.dataset.done = "1";
      var vals = {}, summary = [];
      inputs.forEach(function (it) {
        var v = it.inp.value.trim();
        vals[it.f.key] = v;
        it.inp.disabled = true;
        summary.push(it.f.label + "：" + (v || T.blank));
      });
      btn.disabled = true;
      var text = summary.join(" / ");
      addMsg("user", text);
      recordTurn("user", text);
      onValues(vals);
    }
    btn.addEventListener("click", submit);
    inputs.forEach(function (it, idx) {
      it.inp.addEventListener("keydown", function (e) {
        // IME確定Enterは無視。最後以外は次の欄へ、最後は送信。
        if (e.key === "Enter" && !e.isComposing && e.keyCode !== 229) {
          e.preventDefault();
          if (idx < inputs.length - 1) inputs[idx + 1].inp.focus();
          else submit();
        }
      });
    });
    wrap.appendChild(btn);
    log.appendChild(wrap); appendFlowNav(); scrollDown();
    if (inputs[0]) inputs[0].inp.focus();
  }

  function startFlow() {
    flow = { data: {}, stack: [], transcript: [] };
    setInputEnabled(false);
    step("menu");
  }

  // フロー離脱(メニューへ戻る等)。途中で抜けても入力欄を必ず再有効化する。
  function exitFlow() {
    if (flow) flow = null;
    setInputEnabled(true);
  }

  // "2026/07/20" → "2026年7月20日"。取れなければ元の値を返す。
  function jaDate(s) {
    var p = String(s || "").split(/[\/\-.]/);
    if (p.length < 3 || !p[0]) return String(s || "");
    return (+p[0]) + "年" + (+p[1]) + "月" + (+p[2]) + "日";
  }

  // ---- 交換: 在庫あり選択肢(¥0・AI不要) ----
  function fetchVariants(handle, cb) {
    fetch(VARIANTS_ENDPOINT + "?handle=" + encodeURIComponent(handle))
      .then(function (r) { return r.json(); })
      .then(function (d) { cb(d && d.variants ? d : null); })
      .catch(function () { cb(null); });
  }
  function optKind(name) {
    if (/size|サイズ/i.test(name)) return "size";
    if (/colou?r|カラー|色/i.test(name)) return "color";
    return null;
  }
  // reason(size/color)に対応するオプションで、同じ他オプション・在庫あり・現在値以外の選択肢を返す。
  function exchangeChoices(data, variantTitle, reason) {
    var names = data.optionNames || [];
    var want = reason === "size" ? "size" : "color";
    var targetName = null, otherName = null;
    names.forEach(function (n) { if (optKind(n) === want && !targetName) targetName = n; });
    names.forEach(function (n) { if (n !== targetName && !otherName) otherName = n; });
    var cur = null;
    (data.variants || []).some(function (v) { if (v.title === variantTitle) { cur = v; return true; } return false; });
    var current = cur && targetName ? cur.options[targetName] : null;
    var otherVal = cur && otherName ? cur.options[otherName] : null;
    var seen = {}, values = [];
    if (targetName) {
      (data.variants || []).forEach(function (v) {
        if (!v.available) return;
        if (otherName && otherVal && v.options[otherName] !== otherVal) return;
        var val = v.options[targetName];
        if (val == null) return;
        if (current && val === current) return;
        if (seen[val]) return; seen[val] = 1;
        values.push(val);
      });
    }
    return { targetName: targetName, values: values, current: current };
  }

  function render(id) {
    var d = flow.data;
    switch (id) {
      case "menu":
        botSay(T.menuPrompt);
        renderChoices([
          { icon: "⚠️", label: T.kindDefectInuse, on: function () { d.kind = "defect_inuse"; step("place"); } },
          { icon: "🔁", label: T.kindExchange, on: function () { d.kind = "exchange"; step("place"); } },
          { icon: "↩️", label: T.kindReturn, on: function () { d.kind = "return"; step("return_condition"); } },
        ]);
        break;

      case "return_condition":
        botSay(T.returnCondition);
        renderChoices([
          { label: T.returnCondMeet, on: function () { step("place"); } },
          { label: T.returnCondUnknown, on: function () { d.note = T.returnCondUnknownNote; step("place"); } },
        ]);
        break;

      case "place":
        botSay(T.placePrompt);
        renderChoices([
          { label: T.placeStore, on: function () { d.place = "store"; step("store_name"); } },
          { label: T.placeEc, on: function () { d.place = "ec"; step("ec_order"); } },
        ]);
        break;

      case "store_name":
        botSay(T.storeNamePrompt);
        renderInput(T.phStoreName, true, function (v) {
          d.store_name = v;
          if (d.kind === "defect_inuse") return step("confirm");
          step("store_optional");
        });
        break;

      case "store_optional":
        botSay(T.storeOptionalPrompt);
        renderInput(T.phReceipt, false, function (v) {
          if (v) d.receipt = v;
          step("product_info");
        });
        break;

      case "ec_order":
        if (CUSTOMER.loggedIn && CUSTOMER.orders && CUSTOMER.orders.length) {
          botSay(T.ecRecentPrompt);
          var opts = CUSTOMER.orders.slice(0, 5).map(function (o, i) {
            // ラベルは購入日ベースで簡潔に(商品名まで入れると枠からはみ出すため)。最新は目印を付ける。
            var base = o.created ? t(T.purchaseOn, { date: jaDate(o.created) }) : (o.name || "ご注文");
            return {
              label: base + (i === 0 ? T.latestTag : ""),
              on: function () { pickOrder(o); },
            };
          });
          opts.push({ label: T.ecOrderOther, on: function () { step("ec_order_manual"); } });
          renderChoices(opts);
        } else if (CUSTOMER.loggedIn) {
          // ログイン済みだが注文が見つからない → 手入力へ。
          botSay(T.ecNoOrderFound);
          step("ec_order_manual");
        } else {
          botSay(T.ecLoginHint);
          renderChoices([
            { label: T.ecLoginBtn, on: function () { window.location.href = CUSTOMER.loginUrl || "/account/login"; } },
            { label: T.ecManualBtn, on: function () { step("ec_order_manual"); } },
          ]);
        }
        break;

      case "ec_order_manual":
        botSay(T.ecManualPrompt);
        renderInput(T.phOrderNumber, true, function (v) {
          d.order_number = v;
          if (d.kind === "defect_inuse") return step("confirm");
          step("product_info");
        });
        break;

      case "item_pick":
        botSay(T.itemPickPrompt);
        var its = (flow.pickedOrder && flow.pickedOrder.items) || [];
        var iopts = its.map(function (it) {
          return { label: it.label, on: function () { d.product_info = it.info; afterPurchaseInfo(); } };
        });
        iopts.push({
          label: t(T.itemPickAll, { n: its.length }),
          on: function () { d.product_info = its.map(function (x) { return x.info; }).join(" ／ "); afterPurchaseInfo(); },
        });
        renderChoices(iopts);
        break;

      case "product_info":
        botSay(T.productInfoPrompt);
        renderInputs([
          { key: "item", label: T.fieldItem, placeholder: T.phItem, required: true },
          { key: "color", label: T.fieldColor, placeholder: T.phColor, required: true },
          { key: "size", label: T.fieldSize, placeholder: T.phSize, required: true },
        ], function (v) {
          d.item = v.item; d.color = v.color; d.size = v.size;
          d.product_info = [v.item, v.color, v.size].filter(Boolean).join("／");
          afterPurchaseInfo();
        });
        break;

      case "reason":
        botSay(T.reasonPrompt);
        renderChoices([
          { label: T.reasonInitialDefect, on: function () { d.reason = "initial_defect"; step("receive"); } },
          { label: T.reasonColor, on: function () { d.reason = "color"; step("change_color"); } },
          { label: T.reasonSize, on: function () { d.reason = "size"; step("change_size"); } },
        ]);
        break;

      case "change_color":
        botSay(T.changeColorPrompt);
        renderInput(T.phChangeColor, true, function (v) { d.change = v; step("receive"); });
        break;

      case "change_size":
        botSay(T.changeSizePrompt);
        renderInput(T.phChangeSize, true, function (v) { d.change = v; step("receive"); });
        break;

      // ---- EC交換: 理由(共通) → 商品選択 → 在庫あり選択肢 ----
      case "ex_reason":
        botSay(T.reasonPrompt);
        renderChoices([
          { label: T.reasonInitialDefect, on: function () { d.reason = "initial_defect"; step("ex_items"); } },
          { label: T.reasonColor, on: function () { d.reason = "color"; step("ex_items"); } },
          { label: T.reasonSize, on: function () { d.reason = "size"; step("ex_items"); } },
        ]);
        break;

      case "ex_items": {
        var remaining = exRemaining();
        if (!remaining.length) { step("receive"); break; }
        if (d.reason === "initial_defect") {
          botSay(T.exDefectPick);
          var dopts = remaining.map(function (it) {
            return { label: it.label, on: function () { d.exchanges.push({ item: it.label }); afterExItem(); } };
          });
          if (remaining.length > 1) dopts.push({ variant: "primary", label: T.exAll, on: function () { remaining.forEach(function (it) { d.exchanges.push({ item: it.label }); }); step("receive"); } });
          renderChoices(dopts);
        } else {
          botSay(T.exPickItem);
          renderChoices(remaining.map(function (it) {
            return { label: it.label, on: function () { flow.exItem = it; step("ex_choose"); } };
          }));
        }
        break;
      }

      case "ex_choose": {
        var it = flow.exItem;
        var typing = showTyping();
        fetchVariants(it.handle, function (vdata) {
          typing.remove();
          var res = vdata ? exchangeChoices(vdata, it.variant, d.reason) : { values: [], current: null };
          if (!res.values.length) {
            // 在庫なし → この商品はスキップし、残り継続 or スタッフ相談。
            botSay(t(T.exNoStock, { item: it.label }));
            var opts = [];
            var rest = exRemaining().filter(function (x) { return x.label !== it.label; });
            if (rest.length) opts.push({ label: t(T.exMore, { n: rest.length }), on: function () { step("ex_items"); } });
            opts.push({ label: T.orderStaffBtn, on: function () { startStaffHandoff(); } });
            opts.push({ label: T.exDone, on: function () { step("receive"); } });
            renderChoices(opts);
            return;
          }
          var tmpl = d.reason === "size" ? T.exChooseSize : T.exChooseColor;
          botSay(t(tmpl, { item: it.label, cur: res.current || "-" }));
          renderChoices(res.values.map(function (val) {
            return { label: val, on: function () { d.exchanges.push({ item: it.label, from: res.current || "", to: val }); afterExItem(); } };
          }));
        });
        break;
      }

      case "receive":
        botSay(T.receivePrompt);
        renderChoices([
          { label: T.receiveShip, on: function () { d.receive = "ship"; step("confirm"); } },
          { label: T.receiveStore, on: function () { d.receive = "store"; step("receive_store"); } },
        ]);
        break;

      case "receive_store":
        botSay(T.receiveStorePrompt);
        renderInput(T.phStoreName, true, function (v) { d.receive_store = v; step("confirm"); });
        break;

      case "return_reason":
        botSay(T.returnReasonPrompt);
        renderChoices([
          { label: T.returnReasonSizeNg, on: function () { d.reason = "size_ng"; step("confirm"); } },
          { label: T.returnReasonImageNg, on: function () { d.reason = "image_ng"; step("confirm"); } },
          { label: T.returnReasonOther, on: function () { d.reason = "other"; step("confirm"); } },
          { label: T.returnReasonSkip, on: function () { step("confirm"); } },
        ]);
        break;

      case "confirm":
        botSay(T.confirmPrompt);
        renderSummary(d);
        renderChoices([
          { label: T.confirmBtn, variant: "primary", on: function () { step("terminal"); } },
          { label: T.confirmEdit, on: function () { goBack(); } },
        ]);
        break;

      case "terminal":
        submitFlow();
        break;
    }
  }

  // 確認用の内容サマリを表示。
  function renderSummary(d) {
    var KIND = { defect_inuse: T.kindDefectInuse, exchange: T.kindExchange, return: T.kindReturn };
    var REASON = { initial_defect: T.reasonInitialDefect, color: T.reasonColor, size: T.reasonSize, size_ng: T.returnReasonSizeNg, image_ng: T.returnReasonImageNg, other: T.returnReasonOther };
    var RECV = { ship: T.recvShipLabel, store: T.recvStoreLabel };
    var rows = [];
    var yougen = KIND[d.kind] || "";
    if (d.kind === "exchange" && d.reason) yougen += "（" + (REASON[d.reason] || "") + "）";
    rows.push([T.sumYougen, yougen]);
    if (d.place === "store") rows.push([T.sumPlace, t(T.sumStore, { name: d.store_name || "" })]);
    if (d.place === "ec") rows.push([T.sumOrder, d.order_number || T.blank]);
    if (d.receipt) rows.push([T.sumReceipt, d.receipt]);
    if (d.product_info) rows.push([T.sumProduct, d.product_info]);
    if (d.change) rows.push([T.sumChange, d.change]);
    // EC交換: 商品ごとの交換内容を一覧表示(サイズ M→L 等)。
    if (d.kind === "exchange" && Array.isArray(d.exchanges) && d.exchanges.length) {
      var optJa = d.reason === "size" ? "サイズ" : d.reason === "color" ? "カラー" : "";
      d.exchanges.forEach(function (ex, i) {
        var v = ex.item;
        if (d.reason === "initial_defect") v += "（初期不良）";
        else if (ex.to) v += " ／ " + optJa + " " + (ex.from ? ex.from + "→" : "") + ex.to;
        rows.push(["交換" + (i + 1), v]);
      });
    }
    if (d.kind === "exchange" && d.receive) rows.push([T.sumReceive, d.receive === "store" ? t(T.sumRecvStore, { name: d.receive_store || "" }) : RECV[d.receive]]);
    if (d.kind === "return" && d.reason) rows.push([T.sumReturnReason, REASON[d.reason] || ""]);

    var box = el("div", "cec-summary");
    rows.forEach(function (r) {
      var line = el("div", "cec-summary-row");
      line.innerHTML = '<span class="cec-summary-k">' + escapeHtml(r[0]) + "</span>" + escapeHtml(r[1] || "");
      box.appendChild(line);
    });
    log.appendChild(box);
    scrollDown();
  }

  // 注文を選択。複数商品なら商品選択へ、1点ならそのまま進む。
  function pickOrder(o) {
    var d = flow.data;
    d.order_number = o.name;
    var items = o.items || [];
    if (d.kind === "defect_inuse") {
      // 複数商品なら不良のある商品を選ばせる(先頭固定にしない)。1点ならそのまま。
      if (items.length > 1) { flow.pickedOrder = o; return step("item_pick"); }
      d.product_info = (items[0] && items[0].info) || o.summary || "";
      return step("confirm");
    }
    // EC交換: 理由を1回聞き、商品ごとに在庫あり選択肢で交換先を選ぶ(在庫あり選択ビルダー)。
    if (d.kind === "exchange") {
      flow.exOrder = o;
      d.exchanges = [];
      return step("ex_reason");
    }
    if (items.length <= 1) {
      d.product_info = (items[0] && items[0].info) || o.summary || "";
      return afterPurchaseInfo();
    }
    flow.pickedOrder = o;
    step("item_pick");
  }

  // 交換リストに未登録の商品(handleあり=在庫照会可)を返す。
  function exRemaining() {
    var items = (flow.exOrder && flow.exOrder.items) || [];
    var done = {};
    (flow.data.exchanges || []).forEach(function (e) { done[e.item] = 1; });
    return items.filter(function (it) { return !done[it.label]; });
  }
  // 1商品の交換確定後: 残りがあれば続行を促し、無ければ受取方法へ。
  function afterExItem() {
    var remaining = exRemaining();
    if (!remaining.length) return step("receive");
    botSay(T.exContinue);
    renderChoices([
      { variant: "primary", label: t(T.exMore, { n: remaining.length }), on: function () { step("ex_items"); } },
      { label: T.exDone, on: function () { step("receive"); } },
    ]);
  }

  // 購入分が揃った後の分岐(交換は理由へ／返品は理由任意へ)
  function afterPurchaseInfo() {
    if (flow.data.kind === "exchange") return step("reason");
    if (flow.data.kind === "return") return step("return_reason");
    step("confirm");
  }

  function submitFlow() {
    var typing = showTyping();
    fetch(HANDOFF_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id: sessionId, data: flow.data, transcript: (flow && flow.transcript) || [] }),
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        typing.remove();
        flowBeacon("done", true);
        botSay(t(T.handoffSuccess, { ticket: res.ticket || "" }));
        addHandoff({ ticket: res.ticket, copyText: res.copyText, lineUrl: res.lineUrl });
      })
      .catch(function () {
        typing.remove();
        botSay(T.errCommLine);
      })
      .finally(function () { flow = null; setInputEnabled(true); });
  }

  // 返品・交換の手続き起動ボタンを1つ表示。
  function offerFlowLaunch() {
    var wrap = el("div", "cec-choices");
    var b = el("button", "cec-choice cec-choice-accent", T.flowLaunchBtn);
    b.addEventListener("click", function () {
      if (wrap.dataset.done) return;
      wrap.dataset.done = "1";
      b.disabled = true;
      addMsg("user", FLOW_LAUNCH);
      startFlow();
    });
    wrap.appendChild(b);
    log.appendChild(wrap);
    scrollDown();
  }

  // ---- 用件メニュー(定型化: 大半をボタン/固定回答で解決し、AIは葉だけ) ----

  // チップ/ボタンから定型の質問文をサーバへ(固定回答は¥0で返る)。
  // silent=true: ユーザー発言の吹き出しを追加しない(ボタンのラベルや直前の入力で既に表示済みの時に使う)。
  function sendText(t, silent) { textarea.value = t; send(silent); }

  // トップの用件メニュー。開封時とチップ「メニュー」から表示。
  // 冒頭プロンプト「ご用件を…」は初回のみ表示。以降(戻る/チップ)はメニューのボタンだけ出す。
  // 選択肢ブロックは常に1つに保つ(古いものは消してからボタンを出し直す)。
  var topMenuShown = false;
  function showTopMenu() {
    exitFlow(); // フロー中に戻ってきても入力欄を復活させる。
    [].forEach.call(log.querySelectorAll(".cec-topmenu"), function (n) { n.remove(); });
    if (!topMenuShown) { botSay(T.topMenuPrompt); topMenuShown = true; }
    renderChoices([
      { icon: "🔁", label: T.menuReturn, on: function () { startFlow(); } },
      { icon: "📏", label: T.menuSize, on: function () { startSizeIntake(); } },
      { icon: "❓", label: T.menuFaq, on: function () { showFaqMenu(); } },
    ]);
    if (log.lastElementChild && log.lastElementChild.classList.contains("cec-choices")) log.lastElementChild.classList.add("cec-topmenu");
  }

  function backToMenu() { showTopMenu(); }

  // 配送・送料メニュー(注文状況以外は固定回答¥0)。
  function showDeliveryMenu() {
    botSay(T.deliveryPrompt);
    renderChoices([
      { icon: "💴", label: T.faqShippingFee, on: function () { sendText("送料はいくら", true); } },
      { icon: "📦", label: T.faqDeliveryDays, on: function () { sendText("お届け日数", true); } },
      { icon: "🆓", label: T.faqFreeShip, on: function () { sendText("送料無料はいくらから", true); } },
      { icon: "🔎", label: T.faqOrderStatus, on: function () { checkOrderStatus(); } },
      { label: T.backToMenu, on: backToMenu },
    ]);
  }

  // よくある質問メニュー(すべて固定回答¥0)。
  function showFaqMenu() {
    botSay(T.faqPrompt);
    renderChoices([
      { header: T.faqHeadDelivery },
      { icon: "💴", label: T.faqShippingFee, on: function () { sendText("送料はいくら", true); } },
      { icon: "📦", label: T.faqDeliveryDays, on: function () { sendText("お届け日数", true); } },
      { icon: "🆓", label: T.faqFreeShip, on: function () { sendText("送料無料はいくらから", true); } },
      { icon: "🔎", label: T.faqOrderStatus, on: function () { checkOrderStatus(); } },
      { header: T.faqHeadOther },
      { icon: "💳", label: T.faqPayment, on: function () { sendText("支払い方法", true); } },
      { icon: "🎁", label: T.faqGift, on: function () { sendText("ラッピング", true); } },
      { icon: "🧾", label: T.faqReceipt, on: function () { sendText("領収書", true); } },
      { icon: "🕒", label: T.faqHours, on: function () { sendText("営業時間", true); } },
      { label: T.backToMenu, on: backToMenu },
    ]);
  }

  // 注文状況: ログイン中は即表示(¥0)。未ログインはログイン誘導＋有人。
  function checkOrderStatus() {
    if (CUSTOMER.loggedIn && (CUSTOMER.orders || []).length) {
      botSay(T.orderStatusShow);
      renderOrders();
      sendEvent("order_status_self");
      return;
    }
    if (CUSTOMER.loggedIn) {
      botSay(T.orderNoneLoggedIn);
      renderChoices([
        { label: T.orderStaffBtn, on: function () { startStaffHandoff(); } },
        { label: T.backToMenu, on: backToMenu },
      ]);
      return;
    }
    botSay(T.orderLoginPrompt);
    var opts = [];
    if (CUSTOMER.loginUrl) {
      opts.push({ label: T.orderLoginBtn, on: function () { location.href = CUSTOMER.loginUrl; } });
    }
    opts.push({ label: T.orderByNumberBtn, on: function () { startOrderNumberHandoff(); } });
    opts.push({ label: T.backToMenu, on: backToMenu });
    renderChoices(opts);
  }

  // ---- サイズ: 実寸レコメンド(体型→推定胸囲→サイズ表の身幅と照合。¥0・AI不要) ----
  var sizeCtx = null; // {handle,title,chart,chest,height,weight,build,buildLabel}
  function onProductPage() { return !!(cfg.product && cfg.product.handle); }

  // 推定胸囲/ウエスト(cm)。横幅は体重主導(人体寸法アンカーへの回帰係数)、身長は控えめ。
  // 体重未入力時は体型→BMI(細め19/標準22/筋肉質24/大きめ27)で体重を推定。
  function estWeight(h, build) { var bmi = ({ slim: 19, std: 22, solid: 24, plump: 27 }[build] || 22); return bmi * Math.pow(h / 100, 2); }
  function estimateChest(h, w, build) {
    var weight = w || estWeight(h, build);
    var chest = 0.054 * h + 0.499 * weight + 49;
    if (w) chest += ({ slim: -2, std: 0, solid: 2, plump: 1 }[build] || 0); // 実体重あれば体型で微補正
    return Math.round(chest);
  }
  function estimateWaist(h, w, build) {
    var weight = w || estWeight(h, build);
    var waist = -0.034 * h + 0.608 * weight + 44.6;
    if (w) waist += ({ slim: -2, std: 0, solid: -1, plump: 2 }[build] || 0);
    return Math.round(waist);
  }
  // ボトムのウエストは片幅/周径が混在。<55 は片幅とみなし2倍で周径化。
  function normWaist(v) { return v < 55 ? v * 2 : v; }
  // サイズ表の項目でカテゴリ判定(身幅=トップス / ウエスト=ボトムス)。
  function measureFor(chart) {
    if (!chart || !chart.sizes) return null;
    if (chart.sizes.some(function (s) { return chart.data[s] && chart.data[s]["身幅"] != null; })) return "身幅";
    if (chart.sizes.some(function (s) { return chart.data[s] && chart.data[s]["ウエスト"] != null; })) return "ウエスト";
    return null;
  }
  // サイズの周径(cm): 身幅×2 / ウエスト(正規化)。
  function garmentDim(chart, s, measure) {
    var v = chart.data[s] && chart.data[s][measure];
    if (v == null) return null;
    return measure === "身幅" ? v * 2 : normWaist(v);
  }
  function estimateBody(measure, h, w, build) { return measure === "身幅" ? estimateChest(h, w, build) : estimateWaist(h, w, build); }
  // 着方→ゆとり量(garment周径 − 身体寸, cm)。項目別。
  var EASE = { "身幅": { snug: [6, 12], just: [12, 20], loose: [20, 32] }, "ウエスト": { snug: [-3, 1], just: [1, 5], loose: [5, 11] } };
  // サブ表示: 横幅(身幅/ウエスト)＋縦(着丈/股下)の目安。
  function subFor(chart, measure, rec) {
    var main = measure === "身幅" ? ("身幅 " + rec.raw + "cm") : ("ウエスト約 " + Math.round(rec.g) + "cm（一周）");
    var lk = measure === "身幅" ? "着丈" : "股下";
    var lv = chart.data[rec.size] && chart.data[rec.size][lk];
    return lv != null ? (main + " ／ " + lk + " " + lv + "cm") : main;
  }

  // 在庫サイズ(実寸あり)を表順で。
  function orderedSizes(chart, measure) {
    return chart.sizes.filter(function (s) { return garmentDim(chart, s, measure) != null; });
  }
  // 基準index: ジャスト帯の中央に最も近い(実寸で最適な)サイズ。
  function baseIndexBody(chart, measure, bodyDim) {
    var order = orderedSizes(chart, measure), band = EASE[measure].just, c = (band[0] + band[1]) / 2, bi = 0, bd = 1e9;
    order.forEach(function (s, i) { var d = Math.abs((garmentDim(chart, s, measure) - bodyDim) - c); if (d < bd) { bd = d; bi = i; } });
    return bi;
  }
  function baseIndexTarget(chart, measure, target) {
    var order = orderedSizes(chart, measure), bi = 0, bd = 1e9;
    order.forEach(function (s, i) { var d = Math.abs(garmentDim(chart, s, measure) - target); if (d < bd) { bd = d; bi = i; } });
    return bi;
  }
  // 着方は基準±1サイズ(在庫にクランプ)。すっきり=-1 / ジャスト=0 / ゆったり=+1 → 隣接した自然な並び。
  function pickByOffset(chart, measure, bi, wear) {
    var order = orderedSizes(chart, measure);
    if (!order.length) return null;
    var off = wear === "snug" ? -1 : wear === "loose" ? 1 : 0;
    var s = order[Math.max(0, Math.min(order.length - 1, bi + off))];
    return { size: s, g: garmentDim(chart, s, measure), raw: chart.data[s][measure] };
  }
  // 体型診断: 実寸でジャスト基準を出し、着方は±1サイズ。
  function recommendBody(chart, measure, bodyDim, wear) {
    return pickByOffset(chart, measure, baseIndexBody(chart, measure, bodyDim), wear);
  }
  function fetchChart(handle, cb) {
    fetch(SIZECHART_ENDPOINT + "?handle=" + encodeURIComponent(handle))
      .then(function (r) { return r.json(); })
      .then(function (d) { cb(d && d.chart ? d.chart : null); })
      .catch(function () { cb(null); });
  }

  // ---- 過去購入比較(ログイン客・同カテゴリ購入を基準に実寸で提案) ----
  function isSizeLabelJS(s) {
    return /^(XX?S|S|M|X{0,2}L|LL|3L|4L|F|FREE|ONESIZE|ワンサイズ|フリー|\d{1,3})$/i.test(String(s || "").replace(/\s/g, ""));
  }
  function parseSizeFromVariant(v) {
    var parts = String(v || "").split("/").map(function (x) { return x.trim(); });
    for (var i = 0; i < parts.length; i++) if (isSizeLabelJS(parts[i])) return parts[i].toUpperCase().replace(/\s/g, "");
    return null;
  }
  function isBottomType(t) { return /ボトム|パンツ|スラックス|デニム|スカート|ショーツ|レギンス|ジョガー/i.test(t || ""); }
  // 現商品と同カテゴリ(トップス/ボトムス)の過去購入品(サイズ判別可・現商品除外)。最新順。
  // マイクローゼットのサイズ感メモ(本人分・読込のみ)。キーは商品gid。
  var SIZE_NOTES = (CUSTOMER && CUSTOMER.notes) || null;
  var NOTE_FIT_ADJ = { "少し小さめ": 4, "少し大きめ": -4, "ちょうどいい": 0 };
  function sizeNoteFor(pid) {
    if (!SIZE_NOTES || !pid) return null;
    var n = SIZE_NOTES["gid://shopify/Product/" + pid] || SIZE_NOTES[pid];
    return n && n.fit ? n : null;
  }
  function pastSameCategoryItems(type, currentHandle) {
    var curBottom = isBottomType(type), out = [], seen = {};
    (CUSTOMER.orders || []).forEach(function (o) {
      (o.items || []).forEach(function (it) {
        if (!it.handle) return;
        var same = it.handle === currentHandle;
        if (!same && isBottomType(it.type) !== curBottom) return;
        var sz = parseSizeFromVariant(it.variant);
        if (!sz) return;
        var key = it.handle + "|" + sz;
        if (seen[key]) return; seen[key] = 1;
        out.push({ title: it.title || it.handle, handle: it.handle, size: sz, same: same, note: sizeNoteFor(it.pid) });
      });
    });
    // メモがある候補を優先する。着心地の実感を補正に使えるため。
    var rank = function (c) { return (c.same && c.note) ? 0 : c.note ? 1 : c.same ? 2 : 3; };
    return out.sort(function (a, b) { return rank(a) - rank(b); });
  }

  // 過去購入(最新1点)を基準に自動診断。
  function pickPastReference(it) {
    var typing = showTyping();
    fetchChart(cfg.product.handle, function (curChart) {
      var measure = measureFor(curChart);
      if (!measure) { typing.remove(); return beginSizeDiagnosis(cfg.product.handle, cfg.product.title || "この商品"); }
      fetchChart(it.handle, function (refChart) {
        typing.remove();
        var refG = refChart ? garmentDim(refChart, it.size, measure) : null;
        if (refG == null) {
          botSay(T.pastNoChart);
          return beginSizeDiagnosis(cfg.product.handle, cfg.product.title || "この商品");
        }
        sizeCtx = { handle: cfg.product.handle, title: cfg.product.title || "この商品", chart: curChart, measure: measure, refTitle: it.title, refSize: it.size, refG: refG };
        // サイズ感メモがあれば、着心地の質問を省いてそのまま反映する(やり取りを増やさない)
        if (it.note) {
          sizeCtx.fitAdj = NOTE_FIT_ADJ[it.note.fit] || 0;
          sizeCtx.fitFromNote = it.note.fit;
          return showPastCard();
        }
        askPastFit();
      });
    });
  }
  function askPastFit() {
    botSay(t(T.pastFitAsk, { title: sizeCtx.refTitle, size: sizeCtx.refSize }));
    renderChoices([
      { label: T.pastFitJust, on: function () { sizeCtx.fitAdj = 0; showPastCard(); } },
      { label: T.pastFitLarge, on: function () { sizeCtx.fitAdj = -4; showPastCard(); } },
      { label: T.pastFitSmall, on: function () { sizeCtx.fitAdj = 4; showPastCard(); } },
    ]);
  }
  function showPastCard() {
    botSay(t(T.pastCardLead, { title: sizeCtx.refTitle, size: sizeCtx.refSize }));
    if (sizeCtx.fitFromNote) botSay(t(T.pastFitFromNote, { fit: sizeCtx.fitFromNote }));
    renderSizeCard(function (w) {
      // 前回実寸(+着心地補正)に最も近いサイズを基準に、着方は±1サイズ。
      var target = sizeCtx.refG + (sizeCtx.fitAdj || 0);
      var bi = baseIndexTarget(sizeCtx.chart, sizeCtx.measure, target);
      var r = pickByOffset(sizeCtx.chart, sizeCtx.measure, bi, w);
      return r ? { size: r.size, sub: subFor(sizeCtx.chart, sizeCtx.measure, r) } : null;
    });
  }

  // 入口: 商品を特定 → 過去購入があれば最新1点で自動比較、無ければ体型診断。
  function startSizeIntake() {
    if (onProductPage()) {
      // 先に実寸表を確認。身幅/ウエストが無い商品(リュック等)は体型を聞かず案内へ。
      var typing = showTyping();
      fetchChart(cfg.product.handle, function (chart) {
        typing.remove();
        if (!measureFor(chart)) { return sizeUnavailable(cfg.product.handle, cfg.product.title || "この商品"); }
        if (CUSTOMER.loggedIn) {
          var past = pastSameCategoryItems(cfg.product.type, cfg.product.handle);
          if (past.length) { pickPastReference(past[0]); return; }
        }
        beginSizeDiagnosis(cfg.product.handle, cfg.product.title || "この商品");
      });
      return;
    }
    botSay(T.sizeAskProduct);
    renderInput(T.phSizeProduct, true, function (v) {
      var typing = showTyping();
      fetchSearchRaw(v, function (products) {
        typing.remove();
        if (products && products.length) { beginSizeDiagnosis(products[0].handle, products[0].title); }
        else { botSay(T.sizeNotFound); renderChoices([{ label: T.backToMenu, on: backToMenu }]); }
      });
    });
  }
  // 実寸表が無くサイズ提案できない商品(リュック等)の案内。AI不使用¥0。
  function sizeUnavailable(handle, title) {
    botSay(T.sizeNoChart);
    var opts = [];
    if (handle) opts.push({ icon: "🔗", label: T.sizeViewProduct, on: function () { window.open("/products/" + handle, "_blank"); } });
    opts.push({ icon: "💬", label: T.orderStaffBtn, on: function () { startStaffHandoff(); } });
    opts.push({ label: T.backToMenu, on: backToMenu });
    renderChoices(opts);
  }
  // 商品カードから商品指定でサイズ相談を開始。
  function startSizeIntakeFor(title, handle) {
    if (handle) { beginSizeDiagnosis(handle, title); return; }
    startSizeIntake();
  }

  // 体型プロフィール(出所非依存: 注入=metafield → localStorage)。Level 0=端末記憶。
  var BUILDS = [["slim", T.buildSlim], ["std", T.buildStd], ["solid", T.buildSolid], ["plump", T.buildPlump]];
  function buildLabelOf(key) { for (var i = 0; i < BUILDS.length; i++) if (BUILDS[i][0] === key) return BUILDS[i][1]; return ""; }
  // 表示・保存とも「細身/標準/筋肉質/大きめ」で統一(2026-09-01)。
  // 旧データや別表記(細め・やせ型等)を読めるよう、別名変換は互換目的で残す。
  var BUILD_ALIAS = { "細身": "slim", "細め": "slim", "やせ型": "slim", "標準": "std", "普通": "std", "筋肉質": "solid", "がっちり": "solid", "大きめ": "plump", "ぽっちゃり": "plump" };
  function buildKeyOf(label) {
    for (var i = 0; i < BUILDS.length; i++) if (BUILDS[i][1] === label) return BUILDS[i][0];
    return BUILD_ALIAS[String(label || "").trim()] || null;
  }
  var PROFILE_KEY = "cec_size_profile";
  // 情報源は1つに絞る。ログイン中は顧客メタフィールドのみ、未ログインのみ localStorage。
  // PDPのサイズ診断(size-reco)と同じルール。2つ併用すると登録値と食い違う(2026-09-01)。
  function registeredProfile() {
    var inj = CUSTOMER && CUSTOMER.profile;
    if (!inj || !inj.height || !inj.body_type) return null;
    var key = buildKeyOf(inj.body_type);
    if (!key) return null;
    return { height: parseInt(inj.height, 10) || null, build: key, buildLabel: buildLabelOf(key), weight: parseInt(inj.weight, 10) || null };
  }
  function getSavedProfile() {
    if (CUSTOMER && CUSTOMER.loggedIn) return registeredProfile();
    try { var p = JSON.parse(localStorage.getItem(PROFILE_KEY) || "null"); if (p && p.height && p.build) return p; } catch (e) {}
    return null;
  }
  // 端末記憶は未ログイン専用。ログイン中に書くと二重管理になる。
  function saveProfile(p) {
    if (!p || !p.height || !p.build) return;
    if (CUSTOMER && CUSTOMER.loggedIn) return;
    try { localStorage.setItem(PROFILE_KEY, JSON.stringify(p)); } catch (e) {}
  }
  // 診断値が登録値と違うか
  function profileUnsaved(h, build, w) {
    if (!CUSTOMER || !CUSTOMER.loggedIn) return false;
    var sv = registeredProfile();
    if (!sv) return true;
    if (sv.height !== h || sv.build !== build) return true;
    return !!(w && sv.weight !== w);
  }
  // 体型をアカウントへ保存(App Proxy)。会話を止めないよう選択肢ボタンとして出す。
  // 登録の案内はおすすめの本文に1文足すだけにし、吹き出しを増やさない(2026-09-02)。
  // 以前は「この内容はまだ登録されていません。」という別の吹き出しを挟んでいたが、
  // 答えが出た直後に事務作業を求める形になり、文面も登録済みの人には事実と違っていた。
  function profileInviteLine() {
    if (!CUSTOMER || !CUSTOMER.loggedIn || !sizeCtx || !sizeCtx.height || !sizeCtx.build) return "";
    if (!profileUnsaved(sizeCtx.height, sizeCtx.build, sizeCtx.weight)) return "";
    return " " + T.profileInvite;
  }
  // ボタンは常に「この体型を登録する」の1つ。保存/更新でラベルを変えても動きは同じで、
  // PDP側では同じ文言が別の動きをしていて混乱の元だったため、ここでは1つに固定する。
  function offerProfileSave() {
    if (!profileInviteLine()) return;
    renderChoices([
      {
        label: T.profileSave,
        on: function () {
          var h = sizeCtx.height, build = sizeCtx.build, w = sizeCtx.weight || null;
          fetch("/apps/mypage/size", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ height: h, weight: w, body_type: buildLabelOf(build) })
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res && res.ok) {
                // 体重を空欄で送るとWorkerは既存値を残す。手元の控えも同じ扱いにして表示と登録を一致させる。
                if (CUSTOMER) {
                  var prev = (CUSTOMER.profile && CUSTOMER.profile.weight) || null;
                  CUSTOMER.profile = { height: h, weight: w || prev, body_type: buildLabelOf(build) };
                }
                botSay(T.profileSaved);
              } else { botSay(T.profileSaveFail); }
            })
            .catch(function () { botSay(T.profileSaveFail); });
        }
      }
    ]);
  }

  function beginSizeDiagnosis(handle, title) {
    sizeCtx = { handle: handle, title: title, chart: null, height: null, weight: null, build: null, buildLabel: null };
    var prof = getSavedProfile();
    if (prof && prof.height && prof.build) {
      // 登録済み(metafield/前回入力)なら確認を挟まず、すぐにおすすめを表示。修正はカードの「入力し直す」から。
      sizeCtx.height = prof.height; sizeCtx.build = prof.build; sizeCtx.buildLabel = prof.buildLabel; sizeCtx.weight = prof.weight || null;
      sizeCtx.fromProfile = true;
      computeAndShow();
      return;
    }
    botSay(t(T.diagStart, { title: title }));
    askHeight();
  }
  function askHeight() {
    botSay(T.askHeight);
    renderInput(T.phHeight, true, function (v) {
      var h = parseInt((String(v).match(/\d+/) || [])[0], 10);
      if (!h || h < 120 || h > 220) { botSay(T.heightInvalid); return askHeight(); }
      sizeCtx.height = h; askBuild();
    });
  }
  function askBuild() {
    botSay(T.askBuild);
    var opts = BUILDS.map(function (o) {
      return { label: o[1], on: function () { sizeCtx.build = o[0]; sizeCtx.buildLabel = o[1]; askWeight(); } };
    });
    renderChoices(opts);
  }
  function askWeight() {
    botSay(T.askWeight);
    renderInput(T.phWeight, false, function (v) {
      var w = parseInt((String(v).match(/\d+/) || [])[0], 10);
      if (w && w >= 30 && w <= 200) sizeCtx.weight = w;
      computeAndShow();
    });
  }
  function computeAndShow() {
    // 入力値を端末に記憶(Level 0)。次回は診断入力をスキップして引用できる。
    saveProfile({ height: sizeCtx.height, build: sizeCtx.build, buildLabel: sizeCtx.buildLabel, weight: sizeCtx.weight || null });
    var typing = showTyping();
    fetchChart(sizeCtx.handle, function (chart) {
      typing.remove();
      var measure = measureFor(chart);
      if (!measure) {
        // 実寸が取れない商品(リュック等) → AIに投げず決定的に案内(¥0)。
        return sizeUnavailable(sizeCtx.handle, sizeCtx.title);
      }
      sizeCtx.chart = chart;
      sizeCtx.measure = measure;
      sizeCtx.bodyDim = estimateBody(measure, sizeCtx.height, sizeCtx.weight, sizeCtx.build);
      var wpart = sizeCtx.weight ? "・" + sizeCtx.weight + "kg" : "";
      // 登録の案内はこの1文に同居させる。別の吹き出しにすると手順が1つ増える。
      botSay(t(T.recoLead, { h: sizeCtx.height, build: sizeCtx.buildLabel || "", weight: wpart }) + profileInviteLine());
      renderSizeCard(function (w) {
        var r = recommendBody(sizeCtx.chart, sizeCtx.measure, sizeCtx.bodyDim, w);
        return r ? { size: r.size, sub: subFor(sizeCtx.chart, sizeCtx.measure, r) } : null;
      });
      offerProfileSave();
    });
  }
  // もっと詳しく相談(診断後の二次アクション)の文脈メモ。
  function sizeContextNote() {
    if (!sizeCtx) return "";
    if (sizeCtx.height) return "身長" + sizeCtx.height + "cm・体型" + (sizeCtx.buildLabel || "") + (sizeCtx.weight ? "・体重" + sizeCtx.weight + "kg" : "") + "。";
    if (sizeCtx.refTitle) return "前回「" + sizeCtx.refTitle + "」" + sizeCtx.refSize + "を着用。";
    return "";
  }
  // 自由入力でAIに投げるときに同送する診断コンテキスト(体型＋診断済みの商品と提案サイズ)。
  // 選択肢UIの回答は history に載らないため、これが無いとAIは同じ質問を繰り返す。
  function sizeContextForAI() {
    var base = sizeContextNote();
    if (!base) return "";
    var reco = sizeCtx.recoSize
      ? "診断済みの商品は「" + (sizeCtx.title || "この商品") + "」で、おすすめサイズは" + sizeCtx.recoSize + "。"
      : "";
    return base + reco;
  }
  // おすすめサイズカード。着方(すっきり/ジャスト/ゆったり)は同カードで即切替(吹き出しを増やさない)。
  // compute(wearKey) -> { size, hb } | null
  function renderSizeCard(compute) {
    var cur = "just";
    var card = el("div", "cec-sizecard");
    var lab = el("div", "cec-sizecard-label", T.sizeCardLabel);
    var big = el("div", "cec-sizecard-size", T.sizeCardDash);
    var sub = el("div", "cec-sizecard-sub", "");
    var segLab = el("div", "cec-seg-label", T.wearSegLabel);
    var seg = el("div", "cec-seg");
    var btns = [];
    [["snug", T.wearSnug], ["just", T.wearJust], ["loose", T.wearLoose]].forEach(function (o) {
      var b = el("button", null, o[1]);
      b.setAttribute("data-w", o[0]);
      b.addEventListener("click", function () { cur = o[0]; paint(); });
      seg.appendChild(b); btns.push(b);
    });
    function paint() {
      var r = compute(cur);
      if (!r) return;
      // 自由入力の追い質問でAIに引き継ぐため、現在表示中の提案サイズを保持する。
      if (sizeCtx) sizeCtx.recoSize = r.size;
      big.textContent = r.size;
      sub.textContent = r.sub || "";
      btns.forEach(function (b) { b.classList.toggle("on", b.getAttribute("data-w") === cur); });
    }
    card.appendChild(lab); card.appendChild(big); card.appendChild(sub);
    card.appendChild(segLab); card.appendChild(seg);
    log.appendChild(card);
    // 二次アクション(診断のあとに提示)
    var nav = el("div", "cec-flownav");
    var more = el("button", "cec-flownav-btn", T.sizeMore);
    more.addEventListener("click", function () {
      // 体型・提案サイズは size_context として別途同送されるため、本文には重ねない。
      renderInput(T.sizeMorePh, true, function (v) { askSizeAI(sizeCtx.title, v); });
    });
    var back = el("button", "cec-flownav-btn", T.sizeCardBack);
    back.addEventListener("click", backToMenu);
    nav.appendChild(more);
    // 登録情報から自動表示した場合は、身長・体型を手入力し直す導線を添える。
    if (sizeCtx.fromProfile) {
      var redo = el("button", "cec-flownav-btn", T.sizeRedo);
      redo.addEventListener("click", function () { sizeCtx.fromProfile = false; askHeight(); });
      nav.appendChild(redo);
    }
    nav.appendChild(back);
    log.appendChild(nav);
    paint();
    scrollDown();
  }

  // 「もっと詳しく相談」など実寸で足りない時だけAI(get_size + 体型を踏まえた提案)。
  function askSizeAI(item, body) {
    var q = "「" + (item || "この商品") + "」のサイズについて。" + (body ? body + "。" : "") + "サイズ表の実寸をもとに最適なサイズを、着方も踏まえて教えてください。";
    sendText(q, true);
  }

  // ---- 商品検索: Storefront直検索でカード表示(AI不使用¥0) ----
  // 生の検索結果をコールバックで返す(サイズ相談の商品特定にも使う)。
  function fetchSearchRaw(q, cb) {
    fetch(SEARCH_ENDPOINT + "?q=" + encodeURIComponent(q) + "&n=6")
      .then(function (r) { return r.json(); })
      .then(function (d) { cb((d && d.products) || []); })
      .catch(function () { cb([]); });
  }
  function fetchSearch(q) {
    var typing = showTyping();
    fetch(SEARCH_ENDPOINT + "?q=" + encodeURIComponent(q) + "&n=6")
      .then(function (r) { return r.json(); })
      .then(function (d) {
        typing.remove();
        if (d && d.products && d.products.length) {
          botSay(T.searchResultLead);
          addProducts(d.products);
        } else {
          botSay(T.searchNoResult);
        }
      })
      .catch(function () { typing.remove(); botSay(T.errCommShort); });
  }

  function startProductSearch() {
    botSay(T.searchPrompt);
    renderChoices([
      { icon: "👕", label: T.searchTops, on: function () { fetchSearch("トップス"); } },
      { icon: "👖", label: T.searchBottoms, on: function () { fetchSearch("ボトム"); } },
      { icon: "🧥", label: T.searchOuter, on: function () { fetchSearch("アウター"); } },
      { icon: "🔤", label: T.searchKeyword, on: function () {
          renderInput(T.phSearchKeyword, true, function (v) { fetchSearch(v); });
      } },
      { label: T.backToMenu, on: backToMenu },
    ]);
  }

  // /handoff へ投げて受付番号カードを表示する共通処理(AI不要¥0)。
  function postHandoff(data) {
    var typing = showTyping();
    fetch(HANDOFF_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id: sessionId, data: data }),
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        typing.remove();
        botSay(t(T.handoffSuccess, { ticket: res.ticket || "" }));
        addHandoff({ ticket: res.ticket, copyText: res.copyText, lineUrl: res.lineUrl });
      })
      .catch(function () {
        typing.remove();
        botSay(T.errCommLine);
      });
  }

  // スタッフ相談: 一言入力→受付番号発行→LINE誘導(AI不要¥0)。
  function startStaffHandoff() {
    botSay(T.staffPrompt);
    renderInput(T.phStaff, true, function (v) {
      postHandoff({ kind: "other", note: v });
    });
  }

  // 未ログインの注文照会: 注文番号(任意)を添えて受付発行。
  function startOrderNumberHandoff() {
    botSay(T.orderNumberPrompt);
    renderInput(T.phOrderNumberOpt, false, function (v) {
      postHandoff({ kind: "other", order_number: v, note: T.orderNumberNote });
    });
  }

  // 固定FAQ回答の直後に役立ち評価(👍👎)を1タップで取る。
  function renderFaqFeedback(faqId) {
    var wrap = el("div", "cec-feedback");
    var q = el("span", "cec-feedback-q", T.feedbackQ);
    wrap.appendChild(q);
    [{ label: T.feedbackYes, v: true }, { label: T.feedbackNo, v: false }].forEach(function (o) {
      var b = el("button", "cec-feedback-btn", o.label);
      b.addEventListener("click", function () {
        if (wrap.dataset.done) return;
        wrap.dataset.done = "1";
        fetch(FEEDBACK_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sessionId, faq_id: faqId, helpful: o.v }),
        }).catch(function () {});
        wrap.innerHTML = '<span class="cec-feedback-q">' + escapeHtml(o.v ? T.feedbackThanks : T.feedbackNoThanks) + "</span>";
      });
      wrap.appendChild(b);
    });
    log.appendChild(wrap);
    scrollDown();
  }

  // ---- networking ----
  function send(silent) {
    var text = textarea.value.trim();
    if (!text || sending) return;

    // ログイン中の注文状況・追跡は、注入済みの本人注文データで即表示(AI/サーバを使わない)。
    if (ORDER_INTENT.test(text) && CUSTOMER.loggedIn && (CUSTOMER.orders || []).length) {
      textarea.value = "";
      resize();
      if (!silent) addMsg("user", text);
      addMsg("bot", T.orderStatusShow);
      renderOrders();
      sendEvent("order_status_self");
      history.push({ role: "user", content: text });
      history.push({ role: "assistant", content: T.orderStatusShown });
      if (history.length > 12) history = history.slice(-12);
      persistLog();
      return;
    }

    sending = true;
    sendBtn.disabled = true;
    textarea.value = "";
    resize();
    if (!silent) addMsg("user", text);
    var typing = showTyping();

    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: text,
        history: history,
        session_id: sessionId,
        product_handle: (cfg.product && cfg.product.handle) || undefined,
        size_context: sizeContextForAI() || undefined,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        typing.remove();
        var reply = (data && data.reply) || T.aiFallback;
        addMsg("bot", reply);
        addProducts(data && data.products);
        if (data && data.handoff) addHandoff(data.handoff);
        // 返品/交換の意図が見えたら、手続きフローの起動ボタンを提示(入口を一本化)。
        if (/返品|交換|返金|サイズ.*(変更|交換)|不良|届かない|間違っ/.test(text)) {
          offerFlowLaunch();
        }
        history.push({ role: "user", content: text });
        history.push({ role: "assistant", content: reply });
        if (history.length > 12) history = history.slice(-12);
        persistLog();
        // 固定FAQ回答には役立ち評価(👍👎)を付ける。
        if (data && data.faq_id) renderFaqFeedback(data.faq_id);
      })
      .catch(function () {
        typing.remove();
        addMsg("bot", T.errComm);
      })
      .finally(function () {
        sending = false;
        sendBtn.disabled = false;
      });
  }

  // ---- interactions ----
  var opened = false;
  function toggle(open) {
    panel.classList.toggle("cec-open", open);
    if (open && !opened) {
      opened = true;
      sendEvent("open");
      if (savedState && savedState.m && savedState.m.length) {
        // 同一タブの前ページから会話を復元(テキストのみ)。
        msgLog = savedState.m.slice();
        history = (savedState.h || []).slice();
        msgLog.forEach(function (x) { renderMsgDom(x.role, x.text); });
        // 既に開始済みの会話 → 冒頭プロンプトは再表示しない。
        topMenuShown = true;
        renderSuggestions();
      } else {
        addMsg("bot", GREETING);
        renderSuggestions();
        showTopMenu();
      }
      // 開いた瞬間の自動フォーカスはしない(SPでキーボードが出て画面が上にずれるのを防ぐ)。
      // 入力はユーザーがメッセージ欄をタップした時のみ開始。
    }
  }
  launcher.addEventListener("click", function () {
    toggle(!panel.classList.contains("cec-open"));
  });
  panel.querySelector(".cec-close").addEventListener("click", function () {
    toggle(false);
    flushTranscript();
  });

  function resize() {
    textarea.style.height = "auto";
    textarea.style.height = Math.min(textarea.scrollHeight, 90) + "px";
  }
  textarea.addEventListener("input", resize);
  textarea.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey && !e.isComposing && e.keyCode !== 229) {
      e.preventDefault();
      send();
    }
  });
  sendBtn.addEventListener("click", send);
})();
